/**
 * Created by rcabr on 4/20/2016.
 */

angular.module('eStories.registration.model', [

    /*Global Registration Model*/

]).service('RegistrationModel', ['WS', '$rootScope', 'LL', 'GA', 'AffiliatesProgramModel', function (WS, $rootScope, LL, GA, AffiliatesProgramModel) {
    if (AffiliatesProgramModel.getAllUTMParams()) {
        var utmRequestObj = AffiliatesProgramModel.getUtmRequestObj();
        this.loginWithFacebook = Object.assign({}, this.loginWithFacebook, utmRequestObj);
    }

    this.submitSignUp = async (signUpObj, utmRequestObj) => {
        signUpObj = Object.assign({}, signUpObj, utmRequestObj);
        const response = await WS.callServer('account/signUp', signUpObj);
        if (response.responseStatus === 'SUCCESS') {
            this.prepareAccountSetupEvent('Email', true, response.snid);
        } else {
            this.prepareAccountSetupEvent('Email', false, null);
        }
        return response;
    };

    this.prepareAccountSetupEvent = (method, successful) => {
        fbq('track', 'CompleteRegistration');
        // Get tagObj for ll account set up and save it. then after I refresh user details, send it but only if it's
        // upon signUp

        var tagObj = {
            'Method': method,
            'Success': (successful ? 'YES' : 'NO')
        };
        $rootScope.$broadcast('signUpComplete', tagObj);

    };

    this.submitSignIn = async (signInObj) => {
        const response = await WS.callServer('account/signIn', signInObj);
        if (response && response.responseStatus == 'SUCCESS') {
            this.tagSignInLlEvent(false, true, null);
        } else {
            this.tagSignInLlEvent(false, false, response.responseText);
        }
        return response;
    };

    this.tagSignInLlEvent = (forgotPassword, successful, error) => {
        var tagObj = {
            'Forgot Password': (forgotPassword ? 'YES' : 'NO'),
            'Success': (successful ? 'YES' : 'NO'),
            'Error': error
        };
        LL.tagEvent('Log In', tagObj)
    };

    this.trackSignInGAEvent = () => {
        GA.trackEvent('Account', 'Log In');
    };

    this.trackAccountSetupGAEvent = () => {
        GA.trackEvent('Account', 'Account Setup');
    };

    this.submitFacebookSignIn = () => {
        return new Promise((resolve, reject) => {
            FB.login((fbResponse) => {
                if (!fbResponse.authResponse) {
                    return reject(fbResponse);
                }
                let loginWithFacebook = {
                    accessToken: fbResponse.authResponse.accessToken,
                    device: this.getDeviceObj(),
                };

                if (AffiliatesProgramModel.getAllUTMParams()) {
                    var utmRequestObj = AffiliatesProgramModel.getUtmRequestObj();
                    loginWithFacebook = Object.assign({}, loginWithFacebook, utmRequestObj);
                }
                WS.callServer('account/signInWithFacebook', loginWithFacebook).then(response => {
                    if (response.responseStatus === 'SUCCESS') {
                        if (response.signUp) {
                            this.prepareAccountSetupEvent('Facebook', true, response.snid);
                            this.trackAccountSetupGAEvent();

                        }
                        this.tagSignInLlEvent(false, true, null);
                        this.trackSignInGAEvent();
                    } else if (response.signUp) {
                        this.prepareAccountSetupEvent('Facebook', false, null);
                    }
                    return resolve(response);
                });
            }, {scope: 'email'});
        });
    };

    this.submitGoogleSignIn = async () => {
        return new Promise((resolve, reject) => {
            tokenClient.callback = async (tokenResponse) => {
                await this.handleGoogleLogin(tokenResponse, resolve, reject);
            }
            tokenClient.requestAccessToken();
        });
    }

    this.handleGoogleLogin = async function (tokenResponse, resolve, reject) {
        if (!tokenResponse || !tokenResponse.access_token) {
            reject();
        }

        const accessToken = tokenResponse.access_token;

        var loginWithGoogle = {
            token: accessToken,
            tokenType: "ACCESS_TOKEN",
            device: this.getDeviceObj(),
        };
        if (AffiliatesProgramModel.getAllUTMParams()) {
            var utmRequestObj = AffiliatesProgramModel.getUtmRequestObj();
            loginWithGoogle = Object.assign({}, loginWithGoogle, utmRequestObj);
        }
        const response = await WS.callServer('account/signInWithGoogle', loginWithGoogle);
        if (response.responseStatus === 'SUCCESS') {
            if (response.signUp) {
                this.prepareAccountSetupEvent('Google+', true, response.snid);
                this.trackAccountSetupGAEvent();
            }
            this.tagSignInLlEvent(false, true, null);
            this.trackSignInGAEvent();
        } else if (response.signUp) {
            this.prepareAccountSetupEvent('Google+', false, null);
        }
        return resolve(response);
    };

    this.submitAppleSignIn = async (rememberMe) => {
        const host = window.location.host;
        const REDIRECT_API_URL = `https://${host}/appSignIn`;

        AppleID.auth.init({
            clientId: appleClientId,
            scope: appleScopes,
            redirectURI: REDIRECT_API_URL,
            usePopup: true
        });

        try {
            const data = await AppleID.auth.signIn()

            let code = data.authorization.code;
            let id_token = data.authorization.id_token;
            let firstName;
            let lastName;

            if (data.user) {
                firstName = data.user.name.firstName;
                lastName = data.user.name.lastName;
            }

            if (code !== null && id_token !== null) {

                let request = {
                    code: code,
                    clientId: appleClientId,
                    firstName: firstName,
                    lastName: lastName,
                    device: this.getDeviceObj(),
                    rememberMe: rememberMe
                };


                if (AffiliatesProgramModel.getAllUTMParams()) {
                    let utmRequestObj = AffiliatesProgramModel.getUtmRequestObj();
                    request = Object.assign({}, request, utmRequestObj);
                }

                const response = await WS.callServer('account/signInWithApple', request);

                if (response.responseStatus === 'SUCCESS') {
                    if (response.signUp) {
                        this.prepareAccountSetupEvent('Apple', true, response.snid);
                        this.trackAccountSetupGAEvent();
                    }
                    this.tagSignInLlEvent(false, true, null);
                    this.trackSignInGAEvent();
                } else if (response.signUp) {
                    this.prepareAccountSetupEvent('Apple', false, null);
                }

                return response;
            }
        } catch (error) {
            console.log(error);
        }
    };

    this.resetPassword = (token, newPassword) => {
        var resetPasswordObj = {token: token, password: newPassword};
        return WS.callServer('account/resetPassword', resetPasswordObj);
    };

    this.sendResetPassword = (email) => {
        return WS.callServer('account/sendResetPassword', {email: email});
    };


    this.getDeviceObj = () => {
        return {
            name: 'Web',
            platform: 'WEB',
            deviceType: 'WEB'
        };
    }
}]);
